module.exports = __webpack_public_path__ + "static/media/report.54d76134.svg";